export const publicRoute = {
  home: "/",
  accessibility: "/accessibilite",
};
